export default __webpack_public_path__ + "static/media/49_photo.622c4cde.jpg";